import                          './index.css'
import React, { Suspense }            from 'react'
import ReactDOM                       from 'react-dom'

import { BrowserRouter }              from 'react-router-dom'

import Backdrop                       from '@mui/material/Backdrop'
import CircularProgress               from '@mui/material/CircularProgress'
import { StyledEngineProvider,
         ThemeProvider }              from '@mui/material/styles'
import CssBaseline                    from '@mui/material/CssBaseline'
import reportWebVitals                from './reportWebVitals'

import { darkTheme2 }                  from './theme'
import { printBanner }                from './lib/utils/banner';

const Studio  = React.lazy(() => import('./studio'))
const App     = React.lazy(() => import('./app'))

let isStudio = false
if (process.env.REACT_APP_MODE !== undefined &&
    process.env.REACT_APP_MODE.trim() === "STUDIO") {
  isStudio = true
}

printBanner()

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={darkTheme2}>
            <CssBaseline />
              <Backdrop open={true}>
                <CircularProgress color="inherit" />
              </Backdrop>
          </ThemeProvider>
        </StyledEngineProvider>
      }>
        { isStudio ? <Studio /> : <App /> }
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
